import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Icon from "@mdi/react";
// import { mdiClose, mdiDelete } from "@mdi/js";

import TicketApi from "service/ticketApi";
import { Rating } from "react-simple-star-rating";
import Modal from "react-bootstrap/Modal";

export const ModalChiTiet = ({ toggleModal, TicketId, isModalVisible }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  useEffect(() => {
    TicketApi.chiTietDanhGia(TicketId).then((response) => {
      console.log(response, "1111111111111");
      if (typeof response.data !== "undefined") {
        setData(response.data);
      }
    });
  }, []);

  return (
    <>
      <Modal
        show={isModalVisible}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title  color7-bold" id="myModalLabel16">
            <span className="btn-icon-right"></span> Đánh giá ticket:
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={toggleModal}
          >
            <img src="/app-assets/images/icon-dong-popup-v2.png" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div class="text-left-main">
            <div class="col-sm-12">
              <p className="title-note-ticket">{data.TieuDe}</p>
            </div>

            <div class="col-sm-12">
              <div class="form-group ">
                <div className="form-dg1">
                  <label class="label-control text-left">
                    Chất lượng hỗ trợ:
                  </label>
                  <Rating
                    size={20}
                    transition
                    showTooltip={false}
                    initialValue={data.ChatLuongHoTro}
                    disableFillHover={true}
                    readonly={true}
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group ">
                <label class="label-control text-left">
                  Nhận xét hỗ trợ ticket này
                </label>
                <textarea
                  class="form-control text-left"
                  id="idGhiChu"
                  value={data.Comment}
                  rows="3"
                  cols="20"
                  disabled={true}
                ></textarea>
              </div>
            </div>
            <div class="col-sm-12">
              <div className="form-check-ticket">
                <p>Việc hỗ trợ có kịp thời hay không:</p>
                <div class="check-wrap-ticket" style={{ marginLeft: "40px" }}>
                  <div class="form-check-newMain">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="inlineCheckbox1"
                      checked={data.HoTro}
                    />
                    <label class="form-check-label" for="inlineCheckbox1">
                      Có
                    </label>
                  </div>
                  <div class="form-check-newMain">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="inlineCheckbox2"
                      checked={!data.HoTro}
                    />
                    <label class="form-check-label" for="inlineCheckbox2">
                      Không
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div className="form-check-ticket">
                <p>Có nhân viên liên lạc để hỗ trợ bạn:</p>
                <div class="check-wrap-ticket" style={{ marginLeft: "40px" }}>
                  <div class="form-check-newMain">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="inlineCheckbox12"
                      checked={data.NVHoTro}
                    />
                    <label class="form-check-label" for="inlineCheckbox12">
                      Có
                    </label>
                  </div>
                  <div class="form-check-newMain">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="inlineCheckbox22"
                      checked={!data.NVHoTro}
                    />
                    <label class="form-check-label" for="inlineCheckbox22">
                      Không
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="label-control">
                  Bạn có đề xuất nâng cấp nào cho phần mềm hoàn thiện hơn không?
                </label>
                <textarea
                  class="form-control text-left"
                  id="idGhiChu"
                  value={data.DeXuat}
                  rows="3"
                  cols="20"
                  disabled={true}
                ></textarea>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div class="from-button-modal">
            <div class="row">
              <div class="col-md-9"></div>
              <div class="col-md-3 text-right">
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  onClick={toggleModal}
                >
                  <span class="btn-icon-left">
                    <i class="mdi mdi-close"></i>
                  </span>
                  Đóng
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
